// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import signal from './signal_from_bolmos_make';

console.log("SIGNAL", signal);

Vue.config.productionTip = false

Vue.filter('hex8', (n) => {
    return typeof n === "number" ? n.toString(16).padStart(2, "0") : n;
});

Vue.filter('bin8', (n) => {
    return typeof n === "number" ? n.toString(2).padStart(8, "0") : n;
});

Vue.filter('hex16', (n) => {
    return typeof n === "number" ? n.toString(16).padStart(4, "0") : n;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js